import classNames from 'classnames'
import React from 'react'

function BannerAd({ className }: { className?: string }) {
  return (
    <div className={classNames('w-full flex justify-center relative', className)}>
      <div className='z-10 htlad-leaderboard-top' data-unit='barstool-tv/video' />
      <div className='bg-[#F5F5F5] absolute h-full p-4 min-w-[320px] md:min-w-[720px]'>
        <img
          src='/static/images/stool-and-stars-white.svg'
          alt='stool-and-stars-success'
          className='w-full h-full mx-auto'
        />
        <h4 className='absolute left-[16px] bottom-[16px] text-[#8f8f8f]'>Advertisement</h4>
      </div>
    </div>
  )
}

export default BannerAd
